import { MasterDetailListEntry } from "@sdbn/common";

export class SecureKey implements MasterDetailListEntry {

  listTitleDictionaryKey: string;
  listSubTitle: string;
  childs: MasterDetailListEntry[];
  groupIdentifier: String;

  id: number;
  usage: string;

  constructor(secureKey: Partial<SecureKeyDetails>) {
    this.id = secureKey?.id
    this.usage = secureKey?.usage;
  }

  public get listTitle(): string {
    return this.usage;
  }
}

export class SecureKeyDetails {

  id: number;
  usage: string;
  hashCode: string;
  active: boolean;
  consecutiveNumber: number;
  areaGateAssignments = new Array<AreaGateAssignment>();
  deleted = false;

  constructor(secureKey: Partial<SecureKeyDetails>) {

    this.id = secureKey?.id
    this.usage = secureKey?.usage;
    this.hashCode = secureKey?.hashCode;
    this.active = secureKey?.active;
    this.consecutiveNumber = secureKey?.consecutiveNumber;

    if (secureKey != null && secureKey.areaGateAssignments != null) {
      for (let gate of secureKey.areaGateAssignments) {
        this.areaGateAssignments.push(new AreaGateAssignment(gate));
      }
    }
  }
}

export class AreaGate {

  id: number;
  name: string;

  constructor(areaGate: Partial<AreaGate>) {
    this.id = areaGate?.id
    this.name = areaGate.name;
  }
}


export class AreaGateAssignment {

  id: number;
  areaGateName: string;
  areaGateId: number;
  deleted: boolean;

  constructor(areaGate: Partial<AreaGateAssignment>) {
    this.id = areaGate?.id
    this.areaGateName = areaGate?.areaGateName;
    this.areaGateId = areaGate?.areaGateId;
  }
}
